import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import { cn } from '@/lib/utils';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

export function Breadcrumbs() {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  const breadcrumbItems: BreadcrumbItem[] = [
    { label: 'Home', href: '/' }
  ];

  // Build breadcrumb items based on current path
  let currentPath = '';
  pathnames.forEach((pathname, index) => {
    currentPath += `/${pathname}`;
    
    let label = pathname.charAt(0).toUpperCase() + pathname.slice(1);
    
    // Custom labels for specific routes
    switch (pathname) {
      case 'annotation':
        label = 'Music Annotation';
        break;
      case 'demographics':
        label = 'Demographics';
        break;
      case 'admin':
        label = 'Admin Dashboard';
        break;
    }

    breadcrumbItems.push({
      label,
      href: index === pathnames.length - 1 ? undefined : currentPath
    });
  });

  // Don't show breadcrumbs on home page or login page
  if (pathnames.length === 0 || location.pathname === '/login') {
    return null;
  }

  return (
    <nav className="flex items-center space-x-1 text-sm text-muted-foreground mb-6">
      {breadcrumbItems.map((item, index) => (
        <React.Fragment key={index}>
          {index > 0 && <ChevronRight className="h-4 w-4" />}
          {item.href ? (
            <Link
              to={item.href}
              className="hover:text-foreground transition-colors flex items-center gap-1"
            >
              {index === 0 && <Home className="h-3 w-3" />}
              {item.label}
            </Link>
          ) : (
            <span className={cn("text-foreground font-medium flex items-center gap-1")}>
              {index === 0 && <Home className="h-3 w-3" />}
              {item.label}
            </span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
}